import { LayerKind } from "../plan";
import {
	useFixturesStore,
	useFloorItemsStore,
	useFloorsStore,
	useScreedStore,
	useWallsStore,
	useWaterproofStore,
	useWiringStore,
	usePipesStore,
	usePlumbingStore,
	useCeilingStore,
	useBaseboardStore,
	useWallFinishStore,
	useCommentsStore,
	useUnderlayStore,
} from "../store/layers";

/**
 * Переключить видимость слоя (инверсировать).
 */
export const useToggleVisibleLayer = () => {
	const wallVisible = useWallsStore();
	const fixturesVisible = useFixturesStore();
	const plumbingVisible = usePlumbingStore();
	const furnitureVisible = useFloorItemsStore();
	const floorsVisible = useFloorsStore();
	const waterproofVisible = useWaterproofStore();
	const screedVisible = useScreedStore();
	const wiringVisible = useWiringStore();
	const pipesVisible = usePipesStore();
	const ceilingVisible = useCeilingStore();
	const baseboardVisible = useBaseboardStore();
	const finishVisible = useWallFinishStore();
	const commentsVisible = useCommentsStore();
	const underlayVisible = useUnderlayStore();

	/**
	 * Переключить видимость слоя (инверсировать).
	 */
	const toggleVisibleLayer = (kind: LayerKind, isVisible?: boolean) => {
		switch (kind) {
			case LayerKind.Walls:
				wallVisible.setVisible(isVisible ?? !wallVisible.visible);
				break;
			case LayerKind.Electrical:
				fixturesVisible.setVisible(isVisible ?? !fixturesVisible.visible);
				break;
			case LayerKind.Plumbing:
				plumbingVisible.setVisible(isVisible ?? !plumbingVisible.visible);
				break;
			case LayerKind.Furniture:
				furnitureVisible.setVisible(isVisible ?? !furnitureVisible.visible);
				break;
			case LayerKind.Floors:
				floorsVisible.setVisible(isVisible ?? !floorsVisible.visible);
				break;
			case LayerKind.Waterproof:
				waterproofVisible.setVisible(isVisible ?? !waterproofVisible.visible);
				break;
			case LayerKind.Screed:
				screedVisible.setVisible(isVisible ?? !screedVisible.visible);
				break;
			case LayerKind.Wiring:
				wiringVisible.setVisible(isVisible ?? !wiringVisible.visible);
				break;
			case LayerKind.Pipes:
				pipesVisible.setVisible(isVisible ?? !pipesVisible.visible);
				break;
			case LayerKind.Ceiling:
				ceilingVisible.setVisible(isVisible ?? !ceilingVisible.visible);
				break;
			case LayerKind.Baseboard:
				baseboardVisible.setVisible(isVisible ?? !baseboardVisible.visible);
				break;
			case LayerKind.WallFinish:
				finishVisible.setVisible(isVisible ?? !finishVisible.visible);
				break;
			case LayerKind.Comments:
				commentsVisible.setVisible(isVisible ?? !commentsVisible.visible);
				break;
			case LayerKind.Underlay:
				underlayVisible.setVisible(isVisible ?? !underlayVisible.visible);
				break;
		}
	};

	return toggleVisibleLayer;
};
